import axios from "axios";

import {buildComicsQuery} from "../buildComicsQuery.js";
import {grabComicsNew} from "../grabComicsNew.js";

export function getComicListData(characterID,changeFeaturedComics,limit,showComicArea){
    
    /////// 1. get the comic list data from the API using the characterID in Redux
    /////// 2. then use grabComicsNew() to clean up the returned data to only use what we need
    /////// 3. then store the end results into Redux with changeFeaturedComics()
    var comicQuery = buildComicsQuery(characterID,limit);
    var comicData;

    axios.get(comicQuery)
    .then(function (response1) {
        comicData = grabComicsNew(response1);
        changeFeaturedComics(comicData);
        // console.log("IM THE COMIC DATA")
        // console.log(comicData)
    })  
    .then(function(){
        //this is a reducer function() that controls the comicsAreaReadyToShow property
        //when this is set to true, the character components know to render
        showComicArea(true);
    })
}


// WEBPACK FOOTER //
// ./src/components/includes/axios/getComicListData.js